import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  searchMode: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    padding: '12px 12px 6px 12px',
    borderRadius: 16,
    [theme.breakpoints.up('xs')]: {
      borderTopLeftRadius: 0
    },
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    boxShadow: '0 2px 9px 0 rgb(0 0 0 / 19%)',
    background: theme.palette.grey[800],
    height: '70px',
    width: '100%'
  },
  channelName: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
    padding: '10px 15px',
    borderRadius: '8px 8px 0px 0px',
    background: theme.palette.background.default,
    position: 'absolute',
    top: -44,
    left: 0,
    borderBottom: `1px dashed ${theme.palette.grey[400]}`
  },
  separator: {
    width: 1,
    height: 57,
    borderLeft: 'solid 1px #ababab',
    padding: 5
  },
  searchButton: {
    padding: '8px 16px',
    borderRadius: 10,
    width: '100%',
    fontSize: 20,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      cursor: 'pointer'
    }
  },
  btnText: { color: theme.palette.primary.contrastText, margin: '0 16px' },
  destinationContainer: {
    width: '19%'
  },
  arrivalContainer: {
    width: '23.5%',
    position: 'relative'
  },
  departueContainer: {
    width: '23.5%'
  },
  roomAndGuestContainer: {
    width: '13%',
    position: 'relative'
  },
  currencyContainer: {
    width: '7%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  searchButtonContianer: {
    display: 'flex',
    width: '13.5%',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  dateModal: {
    top: -4,
    left: -12,
    position: 'absolute',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
    width: 796,
    zIndex: 1,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: 9
  },
  nightContainer: {
    height: 69,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: 67,
    paddingTop: 35,
    marginBottom: 0,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: '9px 9px 0 0',
    zIndex: 1000
  },
  guestModal: {
    position: 'absolute',
    display: 'flex',
    flex: 1,
    top: 67,
    left: -11,
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
    padding: '16px 16px',
    width: '100%',
    zIndex: 1000,
    boxShadow: '0 2px 13px 0 rgb(0 0 0 / 17%)',
    borderRadius: 9
  },
  searchIcon: {
    fontSize: '24px'
  },
  currencyLabelColor: {
    color: theme.palette.primary.main,
    fontSize: 13
  },
  autocompleteBorder: {
    border: `0.5px solid ${theme.palette.grey[100]} !important`,
    borderRadius: 6
  },
  currencyRoot: {
    width: '58%',
    minWidth: 80
  },
  adorment: {
    right: 0,
    '& svg': {
      fontSize: '20px'
    }
  },
  buttonBase: {
    width: '60%'
  },
  darkRoot: {
    display: 'flex',
    flexDirection: 'row',
    width: '90',
    background: theme.palette.grey[800],
    position: 'relative',
    padding: '4px 4px ',
    alignItems: 'center',
    justifyContent: 'center',
    height: '80px'
  },
  readMode: {
    display: 'flex',
    flexDirection: 'row',
    width: '95%',
    height: '60%',
    background: theme.palette.grey[800],
    alignItems: 'center'
  },
  left: {
    display: 'flex',
    width: '55%',
    justifyContent: 'flex-start'
  },
  middle: {
    display: 'flex',
    width: '30%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '100%'
  },
  date: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 6,
    background: theme.palette.background.default,
    height: '60%',
    padding: '2px 22px',
    margin: '0px 10px'
  },
  right: {
    display: 'flex',
    width: '20%',
    height: '100%',
    paddingRight: 24,
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '12px 0'
  },
  btn: { height: '100%' },
  searchContainer: {
    display: 'flex',
    background: theme.palette.primary.main,
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    width: 42,
    height: 42
  },
  icon: {
    fontSize: 30,
    color: theme.palette.primary.contrastText
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 6,
    justifyContent: 'space-around'
  },
  individual: { display: 'flex', alignItems: 'flex-start', marginTop: 4 },
  title: { fontWeight: 600, color: theme.palette.grey[200] },
  title2: { fontWeight: 600, color: theme.palette.grey[800] },
  smallTitle: {
    fontWeight: 600,
    color: theme.palette.grey[200],
    marginLeft: 4
  },
  image: { width: 16 },
  red: { fontWeight: 600, color: theme.palette.primary.main, marginRight: 4 },
  text: { fontWeight: 600, color: theme.palette.grey[800] },
  svg: { color: theme.palette.grey[200], fontSize: 20 }
}))
export default useStyles
